import { NormalCode } from '@shared/utils/normalCode';
import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';

@Component({
    selector: 'header-blogroll',
    template: `
    <div *ngIf="data.length">
    <div class="alain-default__nav-item" nz-dropdown [nzDropdownMenu]="menu" nzPlacement="bottomRight">
      <i nz-icon nzType="link" class="alain-default__nav-item-icon"></i>
    </div>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        <li *ngFor="let item of data" nz-menu-item (click)="goto(item)">{{ item.name }}</li>
      </ul>
    </nz-dropdown-menu>
    </div>
  `,
})
export class HeaderBlogrollComponent implements OnInit {
    public data: Array<any> = [];

    constructor(private http: HttpClient, @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService) { }

    queryBlogroll() {
        this.http.post('/feather/otherModle/getTeacherOtherModles', {}).subscribe((response: any) => {
            if (response.err_code === NormalCode.NORMAL_CODE && response.nameUrls) {
                this.data = response.nameUrls;
            }
        });
    }

    goto(result: any) {
        console.log("打开其他模块： ", result.url);
        window.open(result.url);
        // const xhr = new XMLHttpRequest();

        // const params = new FormData();
        // params.set('modleName', result.name);
        // xhr.open('POST', 'http://222.30.195.31/feather/otherModle/openOtherModle', true);
        // xhr.withCredentials = true;
        // xhr.setRequestHeader('token', this.tokenService.get().token);
        // xhr.send(params);
    }
    ngOnInit() {
        this.queryBlogroll();
    }
}
